import React from 'react';
import { Link } from '../../atoms/Link';
import './SubNavItem.css';

export interface SubNavItemProps {
  label: string;
  href: string;
  description: string;
  icon?: string;
  badgeText?: string;
  badgeColor?: string;
  className?: string;
  style?: React.CSSProperties;
}

export const SubNavItem: React.FC<SubNavItemProps> = ({
  label,
  href,
  description,
  icon,
  badgeText,
  badgeColor,
  className = '',
  style,
}) => {
  return (
    <Link
      href={href}
      noUnderline
      className={`hi-ui hi-ui-subnav-item ${className}`.trim()}
      style={style}
    >
      {icon && (
        <div className="hi-ui-subnav-item__icon-container">
          <img src={icon} alt="" className="hi-ui-subnav-item__icon" />
        </div>
      )}
      <div className="hi-ui-subnav-item__content">
        <div className="hi-ui-subnav-item__label">
          {badgeText && (
            <div className="hi-ui-subnav-item__sale-badge">
              <span className="hi-ui-nav-badge" style={{ backgroundColor: badgeColor }}>
                {badgeText}
              </span>
            </div>
          )}
          <span>{label}</span>
        </div>
        <div className="hi-ui-subnav-item__separator" />
        <div className="hi-ui-subnav-item__description">{description}</div>
      </div>
    </Link>
  );
};
